<template>
  <div class="cell b2b-card product-card product-card--has-header" qaid="plpProductCardItem">
    <div class="b2b-card__header product-card__header">
      <product-badge-year :product="product" :base-properties="baseProperties" :qaid="`productCard${itemId}`" />
      <product-compare-button
        v-if="isCompareButtonVisible"
        small
        :product="product"
        :base-properties="baseProperties"
      />
    </div>
    <div class="relative">
      <a
        v-if="isCustomizeVisible"
        href="product.projectOneUrl"
        class="absolute top-0 left-0 inline-block text-sm underline hover:no-underline"
        target="_blank"
        >{{ bp('customize') }}</a
      >
      <a :href="productUrl">
        <img class="b2b-card__img lazyload" :src="currentImageUrl" :alt="product.displayName" />
      </a>
    </div>
    <div class="b2b-card__body text-center">
      <div v-if="swatches" class="product-card__swatches mb-1" qaid="productCardSwatches">
        <swatches :colors="swatches" :radio-name="`swatches-${product.code}`" @color-changed="changeImage" />
      </div>
      <h3 class="b2b-card__title mb-1 font-medium" qaid="productCardProductName">
        <a :href="productUrl">{{ product.displayName }}</a>
      </h3>
      <p class="product-card__price text-sm mt-0 mb-0" qaid="productCardPrice">
        <a :href="productUrl" class="no-underline">
          <span class="product-card__price--sale">{{ price.sale }}</span>
          <span v-if="price.adv" class="product-card__price--adv">{{ price.adv }}</span>
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import productCard from './mixins/product-card';

export default {
  name: 'ProductCardItem',
  mixins: [productCard],
};
</script>
